import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components/atoms/Button/Button';
import { LayoutContainer } from '@/components/molecules/Layout/LayoutContainer';
import Modal from '@/components/atoms/Modal/Modal';
import { BodyMedium } from '@/components/atoms/Typography/Body';
import { H2 } from '@/components/atoms/Typography/Heading';
import { useUpdateSingleCollection } from '@/hooks/collectionsHooks/useUpdateSingleCollection';
import { useDataLayer } from '@/hooks/useDataLayer';
import { cn } from '@/utils/cn';
import React from 'react';
import * as cheerio from 'cheerio';
export const RemoveContentModal = ({ removeContentLabels, contentId, className, isModalOpen, onClose, triggerButton, collection, removedContentIds, contentTitle, ownerId, contentType, ...props }) => {
    const { heading, description, yesDeleteLabel, noCancelLabel } = removeContentLabels;
    const [removeContentSelected, setRemoveContentSelected] = React.useState(false);
    const { mutation } = useUpdateSingleCollection(contentId, collection, removedContentIds);
    const dataLayer = useDataLayer();
    const handleRemoveContent = (event) => {
        event.preventDefault();
        setRemoveContentSelected(true);
        mutation.mutate();
        dataLayer.push({
            event: 'content_item_removed_from_collection',
            collection_name: collection?.name,
            collection_id: collection?.id.externalId,
            content_id: contentId,
            content_title: cheerio
                .load(contentTitle || '')
                .root()
                .text(),
            owner_id: ownerId,
            content_type: contentType,
        });
    };
    React.useEffect(() => {
        if (removeContentSelected && !mutation.isPending) {
            setRemoveContentSelected(false);
            onClose?.(true);
        }
    }, [removeContentSelected, mutation.isPending]);
    return (_jsx(Modal, { openModal: isModalOpen, onClose: () => onClose?.(), heading: heading, description: description, triggerButton: triggerButton, className: "top-1/2 h-fit -translate-y-1/2 rounded-sm md:w-full md:max-w-112", children: _jsx("div", { className: cn(className), ...props, children: _jsxs(LayoutContainer, { palette: "palette-light", spacing: "standard", className: "bg-surface-primary-default text-type-default flex flex-col gap-3 pb-6 text-center", children: [heading && _jsx(H2, { className: "pt-6 md:pt-4", dangerouslySetInnerHTML: { __html: heading || '' } }), description && _jsx(BodyMedium, { className: "pt-1 pb-6", dangerouslySetInnerHTML: { __html: description || '' } }), _jsxs("div", { className: "flex flex-row justify-center gap-4", children: [noCancelLabel && (_jsx(Button, { variant: "secondary", size: "small", onClick: () => onClose?.(), children: noCancelLabel })), yesDeleteLabel && (_jsx(Button, { size: "small", onClick: handleRemoveContent, children: yesDeleteLabel }))] })] }) }) }));
};
export default RemoveContentModal;
